import { $api } from "../../../store/api/api";

import { EndpointsEnum } from "../../../constants/endpoints";

import { IPostTicketRoom, IPostTicketRoomBody, IPostTicketRoomResponse } from "./post-ticket-room.types";
import { IRestResponse } from "../../../types/response";

export const postTicketRoom: IPostTicketRoom = async (body: IPostTicketRoomBody) => {
    const response = await $api.post<IRestResponse<IPostTicketRoomResponse>>(`${EndpointsEnum.POST_TICKET_ROOM}`, body);

    return response.data;
};
